var _toConsumableArray = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "shallowIntl", function () {
      return shallowIntl;
    }), __webpack_require__.d(__webpack_exports__, "mountIntl", function () {
      return mountIntl;
    }), __webpack_require__.d(__webpack_exports__, "skipContextConsumer", function () {
      return skipContextConsumer;
    }), __webpack_require__.d(__webpack_exports__, "mountWithIntlContext", function () {
      return mountWithIntlContext;
    }), __webpack_require__.d(__webpack_exports__, "mountWithTranslatorContext", function () {
      return mountWithTranslatorContext;
    }), __webpack_require__.d(__webpack_exports__, "mountWithTranslatorAndRouterContext", function () {
      return mountWithTranslatorAndRouterContext;
    }), __webpack_require__.d(__webpack_exports__, "TranslatorContextForTest", function () {
      return TranslatorContextForTest;
    }), __webpack_require__.d(__webpack_exports__, "mountRouteComponent", function () {
      return mountRouteComponent;
    }), __webpack_require__.d(__webpack_exports__, "shallowRouteComponent", function () {
      return shallowRouteComponent;
    }), __webpack_require__.d(__webpack_exports__, "textWasTranslated", function () {
      return textWasTranslated;
    }), __webpack_require__.d(__webpack_exports__, "translatorForTests", function () {
      return translatorForTests;
    }), __webpack_require__.d(__webpack_exports__, "flushPromises", function () {
      return flushPromises;
    }), __webpack_require__.d(__webpack_exports__, "shallowContextConsumer", function () {
      return shallowContextConsumer;
    }), __webpack_require__.d(__webpack_exports__, "getPressKey", function () {
      return getPressKey;
    });

    var find_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/find"),
        find_default = __webpack_require__.n(find_),
        external_react_ = __webpack_require__("react"),
        external_react_default = __webpack_require__.n(external_react_),
        external_react_intl_ = __webpack_require__("react-intl"),
        external_react_router_dom_ = __webpack_require__("react-router-dom"),
        locale_ = (__webpack_require__("enzyme"), __webpack_require__("@jutro/locale")),
        external_prop_types_ = __webpack_require__("prop-types"),
        external_prop_types_default = __webpack_require__.n(external_prop_types_),
        external_lodash_ = __webpack_require__("lodash"),
        external_lodash_default = __webpack_require__.n(external_lodash_);

    function shallowRouteComponent(node, context, selector) {
      var initialEntries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ["/"];
      var initialIndex = arguments.length > 4 ? arguments[4] : undefined;
      var router = shallow(external_react_default.a.createElement(external_react_router_dom_.MemoryRouter, {
        initialEntries: initialEntries,
        initialIndex: initialIndex
      }, node), context);
      return (selector ? find_default()(router).call(router, selector) : router.childAt(0)).shallow(context);
    }

    function mountRouteComponent(node, context, selector) {
      var initialEntries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ["/"];
      var initialIndex = arguments.length > 4 ? arguments[4] : undefined;

      var options = function (context) {
        var _context$context, _context$childContext;

        var translator = null == context || null === (_context$context = context.context) || void 0 === _context$context ? void 0 : _context$context.translator,
            translatorContextTypes = null == context || null === (_context$childContext = context.childContextTypes) || void 0 === _context$childContext ? void 0 : _context$childContext.translator;
        return translator && !translatorContextTypes && external_lodash_default.a.set(context, "childContextTypes.translator", external_prop_types_default.a.func.isRequired), context;
      }(context),
          router = mount(external_react_default.a.createElement(external_react_router_dom_.MemoryRouter, {
        initialEntries: initialEntries,
        initialIndex: initialIndex
      }, node), options);

      return selector ? find_default()(router).call(router, selector) : router;
    }

    var _ = __webpack_require__("lodash"),
        translatorForTests = function translatorForTests(key) {
      var defaultMessage = _.get(key, "defaultMessage");

      return defaultMessage ? "Tx: " + defaultMessage : key;
    };

    function textWasTranslated(strOrWrapper, value, args) {
      var text = "string" == typeof strOrWrapper ? strOrWrapper : strOrWrapper.text();
      expect(text).toEqual(translatorForTests(value, args));
    }

    var set_immediate_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/set-immediate"),
        set_immediate_default = __webpack_require__.n(set_immediate_),
        promise_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/promise"),
        promise_default = __webpack_require__.n(promise_);

    var flushPromises = function flushPromises() {
      return new promise_default.a(function (resolve) {
        return set_immediate_default()(resolve);
      });
    };

    function shallowIntl(node) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        locale: "en-US"
      },
          locale = _ref.locale,
          messages = _ref.messages,
          context = _ref.context;

      var intl = new external_react_intl_.IntlProvider({
        locale: locale,
        messages: messages
      }, {}).getChildContext().intl;
      return shallow(external_react_default.a.cloneElement(node, {
        intl: intl
      }), {
        context: _objectSpread({}, context, {
          intl: intl
        })
      });
    }

    function mountIntl(node) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        locale: "en-US"
      },
          locale = _ref2.locale,
          messages = _ref2.messages,
          context = _ref2.context,
          childContextTypes = _ref2.childContextTypes;

      var intl = new external_react_intl_.IntlProvider({
        locale: locale,
        messages: messages
      }, {}).getChildContext().intl;
      return mount(external_react_default.a.cloneElement(node, {
        intl: intl
      }), {
        context: _objectSpread({}, context, {
          intl: intl
        }),
        childContextTypes: _objectSpread({
          intl: external_react_intl_.intlShape
        }, childContextTypes)
      });
    }

    var skipContextConsumer = function skipContextConsumer(wrapper) {
      return find_default()(wrapper).call(wrapper, "ContextConsumer").shallow();
    },
        mountWithIntlContext = function mountWithIntlContext(node) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
      return mount(external_react_default.a.createElement(locale_.IntlProvider, {
        key: locale,
        locale: locale
      }, node));
    },
        mountWithTranslatorContext = function mountWithTranslatorContext(node, locale) {
      return mountWithIntlContext(external_react_default.a.createElement(locale_.TranslatorContext.Provider, {
        value: translatorForTests
      }, node), locale);
    },
        mountWithTranslatorAndRouterContext = function mountWithTranslatorAndRouterContext(node, locale) {
      return mountWithIntlContext(external_react_default.a.createElement(locale_.TranslatorContext.Provider, {
        value: translatorForTests
      }, external_react_default.a.createElement(external_react_router_dom_.MemoryRouter, null, node)), locale);
    },
        TranslatorContextForTest = function TranslatorContextForTest(node) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
      return external_react_default.a.createElement(locale_.TranslatorContext.Provider, {
        value: translatorForTests
      }, external_react_default.a.createElement(locale_.IntlProvider, {
        key: locale,
        locale: locale
      }, node));
    };

    TranslatorContextForTest.__docgenInfo = {
      componentName: "TranslatorContextForTest",
      packageName: "@jutro/test",
      description: "",
      displayName: "TranslatorContextForTest",
      methods: [],
      actualName: "TranslatorContextForTest"
    };

    __webpack_require__("core-js/modules/web.dom-collections.iterator");

    var is_array_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/array/is-array"),
        is_array_default = __webpack_require__.n(is_array_);

    function shallowContextConsumer(node, newContext, oldContext) {
      var _shallow$props;

      var contexts = is_array_default()(newContext) ? newContext : [newContext],
          children = (_shallow$props = shallow(node, oldContext).props()).children.apply(_shallow$props, _toConsumableArray(contexts));

      return shallow(children || external_react_default.a.createElement("div", null), oldContext);
    }

    var for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
        for_each_default = __webpack_require__.n(for_each_),
        test_utils_ = __webpack_require__("react-dom/test-utils");

    var getPressKey = function getPressKey(wrapper, dispatchKeyUpCallbacks) {
      return function (key) {
        var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : wrapper;
        var preventDefaultSpy, stopPropagationSpy;
        return Object(test_utils_.act)(function () {
          var keyboardEvent = new KeyboardEvent("keydown", {
            key: key,
            code: key
          });
          preventDefaultSpy = jest.spyOn(keyboardEvent, "preventDefault"), stopPropagationSpy = jest.spyOn(keyboardEvent, "stopPropagation"), target.getDOMNode().dispatchEvent(keyboardEvent);
        }), wrapper.update(), (null == dispatchKeyUpCallbacks ? void 0 : dispatchKeyUpCallbacks.length) && for_each_default()(dispatchKeyUpCallbacks).call(dispatchKeyUpCallbacks, function (cb) {
          Object(test_utils_.act)(function () {
            cb({
              key: key,
              preventDefault: jest.fn(),
              stopPropagation: jest.fn()
            });
          }), wrapper.update();
        }), {
          preventDefaultSpy: preventDefaultSpy,
          stopPropagationSpy: stopPropagationSpy
        };
      };
    };
  },
  "@babel/runtime-corejs3/core-js-stable/array/is-array": function babelRuntimeCorejs3CoreJsStableArrayIsArray(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/array/is-array");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/find": function babelRuntimeCorejs3CoreJsStableInstanceFind(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/find");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babelRuntimeCorejs3CoreJsStableInstanceForEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/promise": function babelRuntimeCorejs3CoreJsStablePromise(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/promise");
  },
  "@babel/runtime-corejs3/core-js-stable/set-immediate": function babelRuntimeCorejs3CoreJsStableSetImmediate(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/set-immediate");
  },
  "@jutro/locale": function jutroLocale(module, exports) {
    module.exports = require("@jutro/locale");
  },
  "core-js/modules/web.dom-collections.iterator": function coreJsModulesWebDomCollectionsIterator(module, exports) {
    module.exports = require("core-js/modules/web.dom-collections.iterator");
  },
  enzyme: function enzyme(module, exports) {
    module.exports = require("enzyme");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  },
  "prop-types": function propTypes(module, exports) {
    module.exports = require("prop-types");
  },
  react: function react(module, exports) {
    module.exports = require("react");
  },
  "react-dom/test-utils": function reactDomTestUtils(module, exports) {
    module.exports = require("react-dom/test-utils");
  },
  "react-intl": function reactIntl(module, exports) {
    module.exports = require("react-intl");
  },
  "react-router-dom": function reactRouterDom(module, exports) {
    module.exports = require("react-router-dom");
  }
});